<template>
        <modal :show="show" modal-classes="big-modal" :show-close="false">
            <template v-slot:header>
                <h5 class="modal-title" id="DocumentViewer">Dokument ansehen</h5>
            </template>
            <div v-if="type.includes('pdf')" class="text-center">
                <b-embed
                        type="iframe"
                        aspect="4by3"
                        :src="doc.path"
                ></b-embed>
            </div>
            <div v-else-if="type.includes('image')" class="text-center">
                <img :src="doc.path" style="max-width: 100%; height: auto;">
            </div>
            <div v-else>
                Dokumenttyp "{{type}}" wird aktuell nicht unterstützt.
            </div>
            <template v-slot:footer>
                <base-button type="secondary" @click="$store.dispatch('document/clear')">schließen</base-button>
            </template>
        </modal>
</template>

<script>
    export default {
        name:"DocumentViewer",
        data() {
            return {
            }
        },
        computed:{
            doc() {
                return this.$store.state.document;
            },
            show() {
                return this.$store.state.document.path !== '';
            },
            type() {
                return this.$store.state.document.type;
            }
        }
    }
</script>

<style scoped>


</style>